import { Injectable } from '@angular/core';
import { Page } from '@shared/models/page';
import { StoreBase } from 'src/app/stores/abstract';

@Injectable({ providedIn: 'root' })
export class PageStore extends StoreBase<Page> {
  override storeName = 'PageStore';
}
